import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

/** One hit from the global search, in the shape the palette renders. */
export interface SearchHit {
  type: 'client' | 'article' | 'supplier' | 'employee' | 'project' | 'invoice';
  id: string;
  label: string;
  hint?: string;
  href: string;
}

interface SearchResponse {
  results: SearchHit[];
}

/**
 * Global search. Results are scoped SERVER-SIDE to what the caller may read
 * (routes/search/index.ts) — the palette never filters them again, which
 * would only mean the client had already received what it must not show.
 */
export function useGlobalSearch(term: string, options: { enabled?: boolean } = {}) {
  const trimmed = term.trim();
  return useQuery({
    queryKey: ['search', trimmed],
    queryFn: () => apiClient.get<SearchResponse>('/search', { q: trimmed }),
    // A single character matches nearly everything and teaches nothing.
    enabled: (options.enabled ?? true) && trimmed.length >= 2,
    staleTime: 30_000,
  });
}
